<form
    *ngIf="FG"
    nz-form
    [formGroup]="FG"
    [ngClass]="[theme, readOnly ? 'read-only' : '']"
>
    <ng-container *ngFor="let field of fields">
        <!-- normal field -->
        <ng-container *ngIf="field.type !== 'group'">
            <ng-container
                *ngTemplateOutlet="fieldTpl; context: { field: field, FG: FG }"
            >
            </ng-container>
        </ng-container>

        <!-- repeated group (form array) -->
        <ng-container *ngIf="field.type === 'group'">
            <div class="form-array-wrapper">
                <ng-container [formArrayName]="field.name">
                    <nz-form-label
                        *ngIf="
                            field.repeatType === 'user' ||
                            FG.get(field.name)['controls'].length
                        "
                        class="array-label"
                        >{{ field.label }}
                    </nz-form-label>

                    <ng-container
                        *ngFor="
                            let group of FG.get(field.name)['controls'];
                            let i = index
                        "
                    >
                        <div class="form-array-group-wrapper">
                            <ng-container
                                *ngFor="let groupField of field.fields"
                            >
                                <ng-container
                                    *ngTemplateOutlet="
                                        fieldTpl;
                                        context: {
                                            field: groupField,
                                            FG: group
                                        }
                                    "
                                >
                                </ng-container>
                            </ng-container>
                            <button
                                *ngIf="
                                    !field.repeatType ||
                                    field.repeatType === 'user'
                                "
                                nz-button
                                nzSize="small"
                                type="button"
                                class="remove-array-group-btn"
                                (click)="
                                    removeGroupFromRepeatedGroupAtIndex(
                                        field,
                                        i
                                    )
                                "
                            >
                                <i nz-icon nzType="close"></i>
                            </button>
                        </div>
                    </ng-container>
                    <button
                        *ngIf="!field.repeatType || field.repeatType === 'user'"
                        nz-button
                        type="button"
                        (click)="addGroupToRepeatedGroup(field)"
                    >
                        <i class="fa-solid fa-plus"></i>
                        Add
                    </button>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</form>

<ng-template #fieldTpl let-field="field" let-FG="FG">
    <!-- template does not have access to FG so we have to pass it for each field -->
    <ng-container [formGroup]="FG">
        <ng-container *ngIf="!field.isHidden">
            <!-- field condition -->
            <ng-container *ngIf="checkCondition(field.name)">
                <ng-container [ngSwitch]="true">
                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                 section                                 -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-divider
                        *ngSwitchCase="field.type === 'section'"
                        [nzText]="field.label"
                        [attr.data-label]="field.label"
                        [nzOrientation]="
                            field.name === 'healthCardSection'
                                ? 'center'
                                : 'left'
                        "
                    ></nz-divider>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                          text | email | number                          -->
                    <!-- ----------------------------------------------------------------------- -->
                    <nz-form-item
                        class="form-v1-item"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        *ngSwitchCase="
                            field.type === 'text' ||
                            field.type === 'email' ||
                            field.type === 'number'
                        "
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-input-group
                                [nzAddOnBefore]="showLabels && field.label"
                            >
                                <input
                                    nz-input
                                    [type]="field.type"
                                    nzSize="large"
                                    nzBorderless
                                    [formControlName]="field.name"
                                    [placeholder]="
                                        field.standaloneLabel
                                            ? field.placeholder
                                            : field.label
                                    "
                                    [min]="field.min"
                                    [max]="field.max"
                                />
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                 phone                                   -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        class="form-v1-item"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        *ngSwitchCase="field.type === 'phone'"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-input-group
                                [nzAddOnBefore]="showLabels && field.label"
                            >
                                <phone-input
                                    [formControlName]="field.name"
                                    [preferredCountries]="['ca', 'us']"
                                >
                                </phone-input>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item
                        class="form-v1-item"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        *ngSwitchCase="field.type === 'phone164'"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-input-group
                                [nzAddOnBefore]="showLabels && field.label"
                            >
                                <phone164-input
                                    [formControlName]="field.name"
                                    [preferredCountries]="['ca', 'us']"
                                >
                                </phone164-input>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                  area                                   -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        class="form-v1-item area"
                        *ngSwitchCase="field.type === 'area'"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-input-group
                                [nzAddOnBefore]="showLabels && field.label"
                            >
                                <textarea
                                    nz-input
                                    nzSize="large"
                                    nzBorderless
                                    [formControlName]="field.name"
                                    [placeholder]="
                                        field.standaloneLabel
                                            ? field.placeholder
                                            : field.label
                                    "
                                    nzAutosize
                                    [nzAutosize]="{ minRows: 1, maxRows: 6 }"
                                ></textarea>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                  date                                   -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        class="form-v1-item"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        *ngSwitchCase="field.type === 'date'"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <span *ngIf="!field.standaloneLabel" class="label">{{
                            field.label
                        }}</span>
                        <nz-form-control
                            [nzErrorTip]="
                                field.required &&
                                FG.controls[field.name].touched
                                    ? ErrorTip
                                    : null
                            "
                        >
                            <date-input
                                [formControlName]="field.name"
                                format="yyyy-MM-dd"
                            ></date-input>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                  polar                                  -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        *ngSwitchCase="field.type === 'polar'"
                        class="form-v1-item polar"
                    >
                        <span class="label-primary">{{ field.label }}</span>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-radio-group [formControlName]="field.name">
                                <label nz-radio nzValue="Yes">Yes</label>
                                <label nz-radio nzValue="No">No</label>
                            </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                 switch                                  -->
                    <!-- ----------------------------------------------------------------------- -->
                    <nz-form-item
                        *ngSwitchCase="field.type === 'switch'"
                        class="form-v1-item"
                    >
                        <div style="display: flex; align-items: center">
                            <nz-switch
                                [formControlName]="field.name"
                                [nzCheckedChildren]="checkedTemplate"
                                [nzUnCheckedChildren]="unCheckedTemplate"
                            ></nz-switch>
                            <span
                                style="margin-left: 1rem"
                                class="label-text"
                                [innerHTML]="field.label"
                            ></span>

                            <ng-template #checkedTemplate>
                                <i nz-icon nzType="check"></i>
                            </ng-template>
                            <ng-template #unCheckedTemplate>
                                <i nz-icon nzType="close"></i>
                            </ng-template>
                        </div>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                 consent                                 -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        *ngSwitchCase="field.type === 'consent'"
                        class="form-v1-item consent"
                    >
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <label nz-checkbox [formControlName]="field.name">
                                <span class="label-primary">{{
                                    field.label
                                }}</span>
                            </label>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                  file                                   -->
                    <!-- ----------------------------------------------------------------------- -->

                    <ngx-file-drop
                        class="dropzone"
                        *ngSwitchCase="field.type === 'file'"
                        (onFileDrop)="dropped($event, field.name)"
                        [multiple]="false"
                        [directory]="false"
                        dropZoneLabel="Click or drag file to this area
                    to upload"
                        contentClassName="file-content"
                        dropZoneClassName="file-drop"
                    >
                        <ng-template
                            ngx-file-drop-content-tmp
                            let-openFileSelector="openFileSelector"
                        >
                            <div (click)="openFileSelector()" class="content">
                                <h3>
                                    <i
                                        nz-icon
                                        nzType="paper-clip"
                                        nzTheme="outline"
                                        style="margin-right: 5px; color: gray"
                                    ></i>
                                    {{ field.label }}
                                </h3>
                                <p
                                    class="ant-upload-text"
                                    *ngIf="FG.get(field.name).value"
                                >
                                    Click or drag file to this area to upload
                                </p>
                                <p
                                    *ngIf="
                                        field.required &&
                                        FG.get(field.name).errors
                                    "
                                    style="color: red"
                                >
                                    Required
                                </p>
                                <img
                                    class="ant-upload-text"
                                    *ngIf="
                                        FG.get(
                                            field.name
                                        ).value?.mimetype?.indexOf('image') ==
                                            0;
                                        else fileNameTpl
                                    "
                                    [src]="FG.get(field.name).value?.buffer"
                                    style="width: 200px"
                                />
                                <ng-template #fileNameTpl>
                                    {{ FG.get(field.name).value?.originalName }}
                                </ng-template>
                            </div>
                        </ng-template>
                    </ngx-file-drop>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                Single Select                              -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        *ngSwitchCase="field.type === 'singleselect'"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        class="form-v1-item multiselect"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-input-group
                                [nzAddOnBefore]="showLabels && field.label"
                            >
                                <nz-select
                                    nzBorderless
                                    [formControlName]="field.name"
                                    [nzPlaceHolder]="
                                        field.standaloneLabel
                                            ? field.placeholder
                                            : field.label
                                    "
                                    [nzAllowClear]="field.allowClear"
                                >
                                    <nz-option
                                        *ngFor="let option of field.options"
                                        [nzLabel]="option"
                                        [nzValue]="option"
                                    ></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                                Multi Select                              -->
                    <!-- ----------------------------------------------------------------------- -->

                    <nz-form-item
                        *ngSwitchCase="field.type === 'multiselect'"
                        [ngStyle]="{
                            flex: field.width
                                ? 'calc(' + field.width + '% - 0.5rem)'
                                : 'auto'
                        }"
                        class="form-v1-item multiselect"
                    >
                        <nz-form-label
                            *ngIf="field.standaloneLabel"
                            [nzRequired]="field.required"
                        >
                            {{ field.label }}
                        </nz-form-label>
                        <nz-form-control [nzErrorTip]="ErrorTip">
                            <nz-select
                                nzBorderless
                                [nzPlaceHolder]="
                                    field.standaloneLabel
                                        ? field.placeholder
                                        : field.label
                                "
                                [formControlName]="field.name"
                            >
                                <nz-option
                                    *ngFor="let option of field.options"
                                    [nzLabel]="option"
                                    [nzValue]="option"
                                ></nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                               ontario hc                                -->
                    <!-- ----------------------------------------------------------------------- -->

                    <!-- !do not add form-v1-item class -->
                    <nz-form-item
                        *ngSwitchCase="field.type === 'ontario_hc'"
                        class="ontario_hc"
                    >
                        <ontario-hc
                            [disabled]="readOnly"
                            (changeEvent)="patchField(field.name, $event)"
                        >
                        </ontario-hc>
                    </nz-form-item>

                    <!-- ----------------------------------------------------------------------- -->
                    <!--                               Credit Card                               -->
                    <!-- ----------------------------------------------------------------------- -->
                    <nz-form-item
                        *ngSwitchCase="field.type === 'creditcard'"
                        class="creditcard"
                    >
                        <credit-card
                            [formControlName]="field.name"
                            [key]="field.publicKey"
                            (onBusy)="handleBusy($event, field.name)"
                            (onReady)="handleReady($event, field.name)"
                        >
                        </credit-card>
                    </nz-form-item>
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #ErrorTip let-control>
    <ng-container *ngIf="control.hasError('dateInvalid')">
        * Invalid date
    </ng-container>
    <ng-container *ngIf="control.hasError('phoneInvalid')">
        * Invalid phone number
    </ng-container>
    <ng-container *ngIf="control.hasError('email')">
        * Invalid email address
    </ng-container>
    <ng-container *ngIf="control.hasError('required')">
        * This field is required
    </ng-container>
</ng-template>
